import i18n from "i18next";
import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./styles/language-fonts.css";
import { initReactI18next } from "react-i18next";
import enJson from "./locales/en.json";
import idJson from "./locales/id.json";
import jpJson from "./locales/jp.json";
import thJson from "./locales/th.json";
import vnJson from "./locales/vn.json";
import reportWebVitals from "./reportWebVitals";
import getBrowserLanguage from "./utils/getBrowserLanguage";
import { setHtmlLang } from "./utils/setHtmlLang";
import App from "./view/App";

const initialLang = getBrowserLanguage();
setHtmlLang(initialLang);

// Set initial body class for Tailwind font
document.body.classList.remove("font-sans-ja", "font-sans-en");
if (initialLang === "jp") {
  document.body.classList.add("font-sans-ja");
} else {
  document.body.classList.add("font-sans-en");
}

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enJson,
    },
    id: {
      translation: idJson,
    },
    th: {
      translation: thJson,
    },
    vn: {
      translation: vnJson,
    },
    jp: {
      translation: jpJson,
    },
  },
  lng: initialLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

// Listen to language changes and update HTML lang attribute and body class
i18n.on("languageChanged", (lng) => {
  setHtmlLang(lng);
  // Update body class for Tailwind font
  // Remove existing font classes first
  document.body.classList.remove("font-sans-ja", "font-sans-en");
  if (lng === "jp") {
    document.body.classList.add("font-sans-ja");
  } else {
    document.body.classList.add("font-sans-en");
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
